var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Div } from '../Box';
export { OverlayPanel };
export var CleanPanel = React.forwardRef(function (_a, ref) {
    var children = _a.children, closeOnClick = _a.closeOnClick, className = _a.className, props = __rest(_a, ["children", "closeOnClick", "className"]);
    var divRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(divRef.current);
        }
        else {
            ref.current = divRef.current;
        }
    } });
    function handle() {
        var _a;
        if (closeOnClick)
            (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.hide();
    }
    return _jsx(OverlayPanel, __assign({ ref: divRef }, props, { style: __assign({}, props.style), className: "".concat(className || '', " p-overlaypanel__variant__1") }, { children: _jsx(Div, __assign({ noSelect: true, onClick: handle }, { children: children })) }));
});
export var Panel = React.forwardRef(function (_a, ref) {
    var children = _a.children, closeOnClick = _a.closeOnClick, className = _a.className, props = __rest(_a, ["children", "closeOnClick", "className"]);
    var divRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(divRef.current);
        }
        else {
            ref.current = divRef.current;
        }
    } });
    function handle() {
        var _a;
        if (closeOnClick)
            (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.hide();
    }
    return _jsx(OverlayPanel, __assign({ ref: divRef }, props, { className: "".concat(className || '', " p-overlaypanel__variant__2") }, { children: _jsx(Div, __assign({ noSelect: true, onClick: handle }, { children: children })) }));
});
export var PanelModal = React.forwardRef(function (_a, ref) {
    var closeOnClick = _a.closeOnClick, children = _a.children, className = _a.className, props = __rest(_a, ["closeOnClick", "children", "className"]);
    var divRef = React.useRef(null);
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(divRef.current);
        }
        else {
            ref.current = divRef.current;
        }
    } });
    if (typeof closeOnClick === 'undefined')
        closeOnClick = true;
    function handle() {
        var _a;
        if (closeOnClick)
            (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.hide();
    }
    return (_jsx(OverlayPanel, __assign({ ref: divRef }, props, { className: "".concat(className || '', " p-overlaypanel__variant__2") }, { children: _jsx(Div, __assign({ noSelect: true, color: "surface-2", borderLightGrey: true, "b-a-1": true, "py-1": true, onClick: handle }, { children: children })) })));
});
